import { LogoutOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";
import React from "react";
import {
  logoutAuth,
} from "../redux/actions";
import { useAppDispatch } from "../redux/store/hooks";
import IconPeople from "./icons/people";
import IconPerson from "./icons/person";

const Logout: React.FC = () => {
  const dispatch = useAppDispatch();

  const onClick: any = () => {
    dispatch(logoutAuth())
  }

  const items: MenuProps["items"] = [

  ];

  items.push(
    {
      label: "Выйти",
      key: "logout",
      icon: <LogoutOutlined />,
    }
  );

  return (
    <div className="logout-icon">

        <a onClick={(e) => onClick()}>
          <IconPerson/> Выйти
        </a>
    </div>
  );
};

export default Logout;
